import { type AppEnv } from '#app/utils/env.server.ts'

type EnvDisplayConfig = {
  label: string
  headerBg: string
  badgeVisible: boolean
}

export const envDisplayConfig: Record<AppEnv, EnvDisplayConfig> = {
  dev: {
    label: 'dev',
    headerBg: 'bg-red-200 dark:bg-red-800',
    badgeVisible: true,
  },
  staging: {
    label: 'staging',
    headerBg: 'bg-yellow-200 dark:bg-yellow-600',
    badgeVisible: true,
  },
  'self-hosted': {
    label: 'self-hosted',
    headerBg: 'bg-gray-200 dark:bg-gray-700',
    badgeVisible: true,
  },
  offline: {
    label: 'self-hosted',
    headerBg: 'bg-gray-200 dark:bg-gray-700',
    badgeVisible: true,
  },
  labs: {
    label: '',
    headerBg: 'bg-background',
    badgeVisible: false,
  },
  production: {
    label: '',
    headerBg: 'bg-background',
    badgeVisible: false,
  },
}
